import { Button, Modal } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";

import ChangePasswordForm from "./ChangePasswordForm";
import RevalidateMFAWrapper from "./RevalidateMFAWrapper";
import { useLocation } from "react-router";

const ChangePasswordModalButton = () => {
	const [show, setShow] = useState(false);
	const location = useLocation();

	const toggle = useCallback((evt) => {
		evt?.preventDefault();
		setShow((prev) => !prev);
	}, [setShow]);

	useEffect(() => {
		if (location.pathname === '/profile/change-password') {
			toggle();
		}
	}, [location]);

	return (
		<>
			<Button onClick={toggle} variant="primary">
				Change Password
			</Button>
			<Modal centered show={show} size="lg">
				<Modal.Header>
					<Modal.Title>Change Password</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<RevalidateMFAWrapper>
						<ChangePasswordForm cancelText="Close" onCancel={toggle} />
					</RevalidateMFAWrapper>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default ChangePasswordModalButton;